import { call, fork, put, takeEvery } from 'redux-saga/effects';
import * as ga from '../../redux/actions/app';
import {
  GET_TRM_CONFIGURATIONS,
  getTRMConfigurationsSuccess,
  getTRMConfigurationsFail,
  PUT_TRM_CONFIGURATIONS,
  putTRMConfigurationsSuccess,
  putTRMConfigurationsFail
} from '../../redux/actions/trm/systemConfiguration';

import * as api from '../../services/trm/trmServices';
const networkLayerObject = new api.NetworkLayer();

function* getConfigurations(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.getConfigurationAPI,
      payload
    );
    yield put(getTRMConfigurationsSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getTRMConfigurationsFail({ error }));
  }
}

export function* watchTRMGetConfigurations() {
  yield takeEvery(GET_TRM_CONFIGURATIONS, function* () {
    yield fork(getConfigurations);
  });
}

function* putConfigurations(payload) {
  try {
    const response = yield call(
      networkLayerObject.updateConfigurationAPI,
      payload
    );
    yield put(putTRMConfigurationsSuccess(response));
  } catch (error) {
    yield put(putTRMConfigurationsFail({ error }));
  }
}

export function* watchTRMPutConfigurations() {
  yield takeEvery(PUT_TRM_CONFIGURATIONS, function* ({ payload }) {
    yield fork(putConfigurations, payload);
  });
}
